import clsx from 'clsx';
import { Icon, type IconType, LoadingIndicator } from '@seeqdev/qomponents';
import type { ComponentProps } from 'react';

export interface IconWithSpinnerProps {
  id?: string;
  icon?: string;
  spinning: boolean;
  large?: boolean;
  white?: boolean;
  type?: IconType;
  extraClassNames?: string;
  testId?: string;
  customId?: string;
  disabled?: boolean;
}

type LoadingIndicatorSize = ComponentProps<typeof LoadingIndicator>['size'];

const getSpinnerSize = (large?: boolean, extraClassNames?: string): LoadingIndicatorSize => {
  if (extraClassNames?.includes('fa-5x') || extraClassNames?.includes('fa-4x')) {
    return 'xl';
  }

  if (
    extraClassNames?.includes('fa-2x') ||
    extraClassNames?.includes('fa-2xl') ||
    extraClassNames?.includes('tw:text-2xl')
  ) {
    return 'md';
  }

  if (large || extraClassNames?.includes('fa-lg') || extraClassNames?.includes('fa-xl')) {
    return 'sm';
  }

  if (extraClassNames?.includes('tw:text-sm') || extraClassNames?.includes('ai-icon-small')) {
    return 'xs';
  }

  return 'sm';
};

/** Icon that switches to spinner when input parameter is true */
export const IconWithSpinner = ({
  id,
  spinning,
  icon = '',
  large,
  white,
  extraClassNames,
  testId,
  customId,
  disabled = false,
  type = 'theme',
}: IconWithSpinnerProps) => {
  const sharedClassNames = clsx(extraClassNames, {
    'disabledLook cursorNotAllowed': disabled,
  });

  if (spinning) {
    return (
      <LoadingIndicator
        id={id}
        testId={testId}
        customId={customId}
        size={getSpinnerSize(large, extraClassNames)}
        color={white ? '#fff' : undefined}
        extraClassNames={sharedClassNames}
      />
    );
  }

  return (
    <Icon
      id={id}
      testId={testId}
      customId={customId}
      type={white ? 'white' : type}
      icon={icon}
      large={large}
      extraClassNames={sharedClassNames}
    />
  );
};
